import type { ApiError} from '@invite/app-core';
import { AUTH_EXPIRED_EVENT, tokenStore } from '@invite/app-core';

const SESSION_EXPIRED_DELAY_MS = 2000;

/** Every unit of the type is taken: a 409 the server marks with its own code. */
export const isTypeFull = (error: ApiError): boolean =>
  error.status === 409 &&
  typeof error.body === 'object' &&
  error.body !== null &&
  (error.body as Record<string, unknown>)['code'] === 'type_full';

/**
 * For a call made with `keepSessionOn401`: the same sign-out the http layer does on any 401,
 * after the sheet has shown that the session is over.
 */
export const signOutAfterMessage = (): void => {
  window.setTimeout(() => {
    tokenStore.clear();
    window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
  }, SESSION_EXPIRED_DELAY_MS);
};
